<!--
 * @Description: 方案优势 模块
-->
<template>
  <section class="advantage rn-section-gap">
    <div class="container">
      <SectionTitle
        :title="$t('solution.advantages_title')"
        description="ADVANTAGES"
        textAlign="center"
      />
      <div v-if="advantageStyle === 1">
        <div class="row">
          <div
            v-for="(item, index) in list"
            :key="index"
            class="col-lg-6 col-md-6 col-12 p-3 p-lg-5 p-md-5"
          >
            <div class="row card_content">
              <div class="col-lg-7 col-md-12 col-sm-12 col-12">
                <div class="f_title">{{ item.title }}</div>
                <div v-if="item.desc && typeof item.desc === 'string'">
                  <p class="d_title">
                    {{ item.desc }}
                  </p>
                </div>
                <div v-else>
                  <p
                    v-for="(ite, index) in item.desc"
                    :key="index"
                    class="d_title"
                  >
                    {{ ite.title }}
                  </p>
                </div>
              </div>
              <div class="col-lg-5 col-md-12 col-sm-12 col-12 card_img">
                <img :src="item.img" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="advantageStyle === 2">
        <div class="row">
          <div
            v-for="(item, index) in list"
            :key="index"
            class="col-lg-4 col-md-6 col-sm-12 col-12 p-3 p-lg-5 p-md-5"
          >
            <div class="row card_content">
              <div class="">
                <div v-if="item.title" class="f_title2">{{ item.title }}</div>
                <div class="card_img2 mb--30">
                  <img :src="item.img" />
                </div>
                <div>
                  <div v-if="item.desc && typeof item.desc === 'string'">
                    <p class="d_title">
                      {{ item.desc }}
                    </p>
                  </div>
                  <div v-else>
                    <p
                      v-for="(ite, index) in item.desc"
                      :key="index"
                      class="d_title"
                    >
                      {{ ite.title }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SectionTitle from '@/components/elements/sectionTitle/SectionTitle'

export default {
  name: 'Advantage',
  components: { SectionTitle },
  props: {
    /**
     * 1：两列；2、三列
     * 默认为 1。
     */
    advantageStyle: {
      type: Number,
      default: 1
    },
    /**
     * list: 数组
     * 格式：[{ title: '1', desc:'1', img: require('01.png') },{ title: '2', desc:'2', img: require('02.png') }]
     * desc为数组时的格式：[{ title: '1', desc:[{ title: '1' },{ title: '2' }], img: require('01.png') }]
     * tab无title时的格式：[{ desc:'1', img: require('01.png') },{ desc:'2', img: require('02.png') }]
     */
    list: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
    }
  },
  methods: {

  }
}
</script>